import gql from 'graphql-tag'

export const getInsureds = gql`
  query($paging: PagingQuery, $order: InsuredsOrder, $filter: InsuredsFilter!) {
    getInsureds(
      paging: $paging,
      order: $order,
      filter: $filter,
    ) {
      insureds {
        id
        name
        relationShip
        gender
        includedOrExcluded
        usCitizen
        notes
        firstName
        middleName
        lastName
        educationLevel
        socSec
        dateOfBirth
        maritalStatus
        driversLicenseNumber
        licenseStatus
        accidentsOrViolations
        licenseState
        matureDriver
        studentFarAway
        goodStudent
        defensiveDriverCourseDate
        ddcExpiredDate
        dateLicensed
        goodDriver
        driverTraining
        dui
        srOrFr
        currentEmployerInformation
        previousEmployerInformation
        employerPhone
        occupationClassCode
        title
        occupationYears
        expectedAnnualIncome
        additionalIncome
        aagIncome
        employerHealthInsurance
        employeeOHIAmount
        spouseEOInsurance
        spouseEOHIAmount
        tobaccoUser
        receivesMedicareOrMedicaid
        receiveSocialSecurityBenefits
        needsInsurance
        preExistingConditions
        medications
        weight
        height
        healthClass
        quote {
          id
          name
        }
        policy {
          id
          policyName
        }
        createdAt
        updatedAt
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const getInsured = gql`
  query($insuredId: Int!) {
    getInsured(
      insuredId: $insuredId,
    ) {
      id
      name
      relationShip
      gender
      includedOrExcluded
      usCitizen
      notes
      firstName
      middleName
      lastName
      educationLevel
      socSec
      dateOfBirth
      maritalStatus
      driversLicenseNumber
      licenseStatus
      accidentsOrViolations
      licenseState
      matureDriver
      studentFarAway
      goodStudent
      defensiveDriverCourseDate
      ddcExpiredDate
      dateLicensed
      goodDriver
      driverTraining
      dui
      srOrFr
      currentEmployerInformation
      previousEmployerInformation
      employerPhone
      occupationClassCode
      title
      occupationYears
      expectedAnnualIncome
      additionalIncome
      aagIncome
      employerHealthInsurance
      employeeOHIAmount
      spouseEOInsurance
      spouseEOHIAmount
      tobaccoUser
      receivesMedicareOrMedicaid
      receiveSocialSecurityBenefits
      needsInsurance
      preExistingConditions
      medications
      weight
      height
      healthClass
      createdAt
      updatedAt
      quote {
        id
        name
      }
      policy {
        id
        policyName
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
    }
  }
`

export const newInsured = gql`
  mutation($insuredInput: InsuredInput!) {
    newInsured(
      insuredInput: $insuredInput,
    ) {
      id
    }
  }
`

export const editInsured = gql`
  mutation($insuredId: Int!, $insuredInput: InsuredInput!) {
    editInsured(
      insuredId: $insuredId,
      insuredInput: $insuredInput,
    ) {
      id
    }
  }
`

export const deleteInsured = gql`
  mutation($insuredId: Int!) {
    deleteInsured(
      insuredId: $insuredId,
    )
  }
`
